module.exports = __webpack_public_path__ + "static/tpdp-d98b5a10222389c9649e61349097d3a4.png";